import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import clasnames from 'classnames';
import moment from 'moment';
import AnonymousTab from './AnonymousTab';
import CustomerTab from './CustomerTab';

import Tabs from 'src/components/Tabs/Tabs';
import { observer } from 'mobx-react';

@observer
class CustomersBar extends React.Component {
    static propTypes = {
        customers: ImmutablePropTypes.map,
        opened: ImmutablePropTypes.list,
        onOpenRequest: PropTypes.func.isRequired,
        onCloseRequest: PropTypes.func.isRequired,
        getCustomerFreeCredits: PropTypes.func.isRequired,
    };

    static defaultProps = {
        customers: List(),
        opened: List(),
    };

    constructor(props) {
        super(props);
        // this.customerData = appState.models.getUserModel(props.id).basicData.data;
        this.state = {
            parameters: {},
        };
    }
    // componentDidMount() {
    //     // this.loadCustomer(this.props);
    //     this.loadCustomer(this.props);
    // }

    // UNSAFE_componentWillReceiveProps(props) {
    //     // if (
    //     //     props.route !== this.props.route ||
    //     //     props.customers.getIn([ props.id, 'state' ]) !== this.props.customers.getIn([ props.id, 'state' ])
    //     // ) {
    //     //     this.loadCustomer(props);
    //     // }
    //     this.loadCustomer(props);
    // }

    // loadCustomer(props) {
    //     const idStr = $appState.routerBackoffice.getValueString('customers');
    //     console.info('CustomersBar -> loadCustomer ...', { idStr, props });

    //     const id = parseInt(idStr, 10);

    //     if (isNaN(id)) {
    //         return;
    //     }

    //     const user = props.opened.find(o => o === id);

    //     // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    //     if (!user || props.customers.getIn([ id, 'state' ]) === 'ERROR') {
    //         console.info('CustomersBar -> OPEN ....', id);
    //         this.props.onOpenRequest(id);
    //         this.props.getCustomerFreeCredits(id);
    //     }
    // }

    onChange(tab) {
        const userId = parseInt(tab, 10);

        let path,
            params = {};

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!isNaN(userId) || tab) {
            path = `customers:${tab}`;
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            params = (this.props.history && this.props.history.get(userId)) || {};
        } else {
            path = 'customers';
        }

        const currentParameters = $appState.routerBackoffice.getParametersAllFromNamespace('customers');
        this.setState(
            {
                parameters: new Map(Object.entries(currentParameters)),
            },
            () => {
                $appState.routerBackoffice.redirectToNamespace(path, params);
            }
        );
    }

    onClose(tab) {
        const { onCloseRequest, opened } = this.props;

        const userId = parseInt(tab, 10);

        if (isNaN(userId)) {
            return;
        }

        onCloseRequest(userId);

        // if current and not last tab is closing, change current tab to last inactive.
        if (opened.size > 1 && $appState.routerBackoffice.getValueString('customers') === tab) {
            this.onChange(opened.findLast((o) => o != userId));
        }
    }

    render() {
        const { opened, customers, onSaveHistoryRequest, history } = this.props;
        const route = $appState.routerBackoffice.getValueString('customers');

        //TODO - temporary way of loading user data information
        setTimeout(() => {
            const idStr = $appState.routerBackoffice.getValueString('customers');

            const id = parseInt(idStr, 10);

            if (isNaN(id)) {
                return;
            }

            const user = this.props.opened.find((o) => o === id);

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (!user || this.props.customers.getIn([id, 'state']) === 'ERROR') {
                this.props.onOpenRequest(id);
                this.props.getCustomerFreeCredits(id);
            }
        }, 0);

        let active = parseInt(route, 10);
        if (isNaN(active)) {
            active = route;
        }

        return (
            <Tabs
                className={clasnames('tabs__customers-bar', { 'is-single': opened.size === 0 })}
                onChange={this.onChange.bind(this)}
                onClose={this.onClose.bind(this)}
                allowNoActive={true}
                allowClose={true}
                allowSideScroll={true}
                active={active}
            >
                {opened
                    .map((id) => {
                        const customer = customers.get(id);
                        const customerData = customer.get('data');

                        let accountStatusValue;
                        let isAccountBlocked;
                        if (typeof customerData !== 'undefined') {
                            accountStatusValue = customerData.getIn(['status', 'value']);
                            isAccountBlocked =
                                accountStatusValue === 'blocked' ||
                                accountStatusValue === 'suspended' ||
                                accountStatusValue === 'pending' ||
                                accountStatusValue === 'closed' ||
                                moment(Date.now()).isBefore(moment(customerData.get('playBreakExpiry')))
                                    ? true
                                    : false;
                        }

                        let label = customer.get('state') === 'ERROR' ? 'Error' : customer.get('name');
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        if (!label) {
                            label = 'Loading...';
                        }
                        return (
                            <CustomerTab
                                key={id}
                                id={id}
                                href={`/customer?id=${id}`}
                                label={label}
                                onSaveHistory={onSaveHistoryRequest}
                                history={history}
                                isAccountBlocked={isAccountBlocked}
                                parameters={this.state.parameters}
                            />
                        );
                    })
                    .toArray()}
                <AnonymousTab
                    key='anonymous'
                    label='+'
                    className='customers-bar-new'
                />
            </Tabs>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default CustomersBar;
